

























function getCachedRecord(
  store,
  filterFn,
  options = {isPlural: false}
) {
  const sources = store.__recordSource.__mutator.__sources
  const filteredRecords = []
  for (let ss = 0; ss < sources.length; ss++) {
    const source = sources[ss]
    const records = source._records
    // relay again does something silly & nests their source in a source because they can't figure out optmistic updating
    let optimisticRecords
    if (!records) {
      optimisticRecords = {
        ...source._base._records,
        ...source._sink._records
      }
    }
    const allRecords = records || optimisticRecords

    for (const record of Object.values(allRecords)) {
      if (filterFn(record)) {
        if (!options.isPlural) return record
        filteredRecords.push(record)
      }
    }
  }
  return filteredRecords
}

export default getCachedRecord
